import Wrong from './wrong';

export default Wrong;